import FocusRoom from '@/components/FocusRoom'
import { createFileRoute } from '@tanstack/react-router'
import { guardFocusRoom } from '../lib/auth/routeGuards'

export const Route = createFileRoute('/focus-room')({
  beforeLoad: guardFocusRoom,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <FocusRoom />
    </div>
  )
}
